import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const d=i("iceland",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5L24 20.5L0 20.5L0 4.5Z"
                fill="#0051A2" />
            <path
                d="M10.56 20.5H6.72L6.72 14.2778L0 14.2778L0 10.7222H6.72L6.72 4.5L10.56 4.5L10.56 10.7222L24 10.7222V14.2778L10.56 14.2778V20.5Z"
                fill="white" />
            <path
                d="M9.6 20.5H7.68L7.68 13.3889L0 13.3889L0 11.6111H7.68L7.68 4.5L9.6 4.5L9.6 11.6111L24 11.6111V13.3889L9.6 13.3889V20.5Z"
                fill="#DC1E35" />
        </svg>
    `),p=i("iceland_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_66524)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M-4.66797 0.5L28.6654 0.5L28.6654 24.5L-4.66797 24.5L-4.66797 0.5Z"
                    fill="#0051A2" />
                <path
                    d="M9.9987 24.5L4.66536 24.5L4.66536 15.1667L-4.66797 15.1667L-4.66797 9.83333L4.66536 9.83333L4.66536 0.5L9.9987 0.5L9.9987 9.83333L28.6654 9.83333V15.1667L9.9987 15.1667L9.9987 24.5Z"
                    fill="white" />
                <path
                    d="M8.66536 24.5L5.9987 24.5L5.9987 13.8333L-4.66797 13.8333V11.1667L5.9987 11.1667L5.9987 0.5L8.66536 0.5L8.66536 11.1667L28.6654 11.1667V13.8333L8.66536 13.8333L8.66536 24.5Z"
                    fill="#DC1E35" />
            </g>
            <defs>
                <clipPath id="clip0_19470_66524">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{d as Iceland,p as IcelandRounded};
